export const TABLE_HEAD: Array<HeadCellConfig> = [
  { id: 'order_number', label: 'Mã đơn hàng' },
  { id: 'grand_total', label: 'Tổng tiền', align: 'right' },
  { id: 'state', label: 'Tình trạng đơn' },
  { id: 'is_payment', label: 'Thanh toán' },
  { id: 'created_at', label: 'Ngày tạo đơn' },
];
